import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { getRoute } from '@common/constants/CampusRoutes';

import ImpersonatePage from './Impersonate';

function ImpersonateRoute() {
	return (
		<Routes>
			<Route path="/" element={<ImpersonatePage />} />
			<Route path="*" element={<Navigate to={getRoute(['NEWS'])} replace />} />
		</Routes>
	);
}

export default ImpersonateRoute;
